export default "__VITE_ASSET__Cq2FtVs8__"